/* eslint-disable no-console */
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable, ErrorHandler, isDevMode } from '@angular/core';

import * as Sentry from '@sentry/browser';
import BASE from '@senet-id/app.base';
import { isProduction } from '@senet-id/backend-url.config';

@Injectable({ providedIn: 'root' })
export class ErrorService implements ErrorHandler {
  constructor() {
    if (!isDevMode()) {
      Sentry.init({
        dsn: BASE.sentryDSN,
        release: BASE.version,
        environment: isProduction ? 'production' : 'development',
      });
    }
  }

  handleError(error: any) {
    if (!isDevMode()) {
      if (error instanceof HttpErrorResponse) {
        if (error.status >= HttpStatusCode.InternalServerError) {
          const message = `${error.message}; ${JSON.stringify(error.error)}`;

          Sentry.captureException(message);
        }
      } else {
        Sentry.captureException(error.originalError || error);
      }
    }

    console.error(error);
  }
}
